module.exports = __webpack_public_path__ + "img/2.d297e6ac.svg";